import { FlexContainer, Accordion } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const QuestionsContainer = styled(FlexContainer)`
  flex-direction: column;
  width: 450px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const DetailAccordion = styled(Accordion)`
  width: 100%;
  margin-bottom: ${({ theme: { spacing } }) => spacing.spacing_16};
  background: ${({ theme: { colors } }) => `${colors.white}80`};
  > .accordion-parent {
    border: 0;
  }
`;

export const StyledList = styled.ul`
  list-style-type: disc;
  color: ${({ theme: { colors } }) => colors.dark_500};
  padding-left: ${({ theme: { spacing } }) => spacing.spacing_16};
  margin: 0;
`;
